var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1393.878,
    height: 386.444,
    viewBox: "0 0 1393.878 386.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(1052.659 -1466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(-1052.659 1466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M0,144.917C0,64.729,64.272,0,143.895,0S287.79,64.729,287.79,144.917c0,96.611-143.895,241.528-143.895,241.528S0,241.528,0,144.917Zm143.895,96.611c53.243,0,95.93-42.99,95.93-96.611,0-53.137-42.687-96.611-95.93-96.611-52.762,0-95.93,43.474-95.93,96.611a96.659,96.659,0,0,0,13.875,50.107l18.107-18.238a10.881,10.881,0,0,1,15.458,0l1.931,1.948,27.678-27.877-13.524-13.62-1.931,1.945a8.152,8.152,0,0,1-11.593,0L90.239,131.4a8.293,8.293,0,0,1,0-11.675l42.506-42.808a8.158,8.158,0,0,1,11.593,0l7.727,7.782a8.3,8.3,0,0,1,0,11.675l-1.934,1.948,38.644,38.915,1.931-1.945a8.158,8.158,0,0,1,11.593,0l7.727,7.782a8.293,8.293,0,0,1,0,11.675l-42.506,42.808a8.154,8.154,0,0,1-11.59,0l-7.731-7.782a8.3,8.3,0,0,1,0-11.675l1.934-1.945-13.527-13.623-27.678,27.877,1.931,1.945a11.062,11.062,0,0,1,0,15.568L92.44,226.472A95.077,95.077,0,0,0,143.895,241.528Z",
    fill: "#fb1da4"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Lawyers_NowNow",
    "data-name": "Lawyers NowNow",
    transform: "translate(-704.78 1727.192)",
    fill: "#fff",
    fontSize: 116,
    fontFamily: "LucidaGrande-Bold, Lucida Grande",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Lawyers"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "NewPeninimMT-Bold, New Peninim MT"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "NowNow")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.903589f865ad6053cb52d9b52ce7e5ca.svg";
export { ForwardRef as ReactComponent };